export const AddFilterSVG = ({ fill }: { fill: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.54169 5.17516C5.47503 7.6585 8.33336 11.3335 8.33336 11.3335V15.5002C8.33336 16.4168 9.08336 17.1668 10 17.1668C10.8462 17.1668 11.5503 16.5278 11.6536 15.7085H11.4584C10.4228 15.7085 9.58336 14.869 9.58336 13.8335C9.58336 12.798 10.4228 11.9585 11.4584 11.9585H11.6667V11.3335C11.6667 11.3335 14.525 7.6585 16.4584 5.17516C16.8834 4.62516 16.4917 3.8335 15.7917 3.8335H4.20003C3.50836 3.8335 3.11669 4.62516 3.54169 5.17516ZM14.1667 17.1668C14.1667 17.6271 14.5398 18.0002 15 18.0002C15.4603 18.0002 15.8334 17.6271 15.8334 17.1668V14.6668H18.3334C18.7936 14.6668 19.1667 14.2937 19.1667 13.8335C19.1667 13.3733 18.7936 13.0002 18.3334 13.0002H15.8334V10.5002C15.8334 10.0399 15.4603 9.66683 15 9.66683C14.5398 9.66683 14.1667 10.0399 14.1667 10.5002V13.0002H11.6667C11.2065 13.0002 10.8334 13.3733 10.8334 13.8335C10.8334 14.2937 11.2065 14.6668 11.6667 14.6668H14.1667V17.1668Z"
        fill={fill}
      />
    </svg>
  );
};
